import { createApp } from 'vue';

import MiniCalendarWidget from "./widgets/MiniCalendarWidget";

document.querySelectorAll('.cal-component').forEach((miniCalendarWidgetEl) => {
    const miniCalendarWidget = createApp(MiniCalendarWidget, { ...miniCalendarWidgetEl.dataset });
    miniCalendarWidget.mount(miniCalendarWidgetEl);
});